import { handleFormError } from 'assets/js/misc';

angular.module('logbook').directive('tagEditor', ['$http', '$timeout', '$q', function($http, $timeout, $q) {
   return {
      redirect: 'E',

      scope: {
         selectedLog: '='
      },

	  template: require('./tag-editor.html'),
	  
      bindToController: {
         selectedLog: '=',
         tagValues: '=?',
         tags: '=?',
         refreshTags: '=?',
         resolveStyles: '=?',
         totalTags: '=?'
      },
      controller: ['$scope', function($scope) {
         
         $scope.parentTagValues = {};
         $scope.parentTagValueObjects = {};
         
         $scope.resolveStyles = function(tagValue)
         {
            tagValue.resolvedStyles = '';
            tagValue.styles.forEach(function(style) {
               tagValue.resolvedStyles += style.name + ' ';
            });
         };
         this.refreshTags = function(tableState)
         {
            var params = {
                  'log': $scope.selectedLog.id,
                  'projection': 'tagValueProjectionWithParents',
                  'size': 20
            };
            if( tableState )
               $scope.tableState = tableState;
            else
               tableState = $scope.tableState;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;
            var number = pagination.number || 15;
            var pageNr = Math.ceil(start/number);
            if( !tableState.sort.predicate )
               return;
            tableState.search.predicateObject
               && Object.keys(tableState.search.predicateObject).forEach(function(key) {
               if( key == 'stringValue' || key == 'description')
                  params[key] = '%'+tableState.search.predicateObject[key]+'%';
               else
                  params[key] = tableState.search.predicateObject[key];
            });
            var sort = tableState.sort.predicate;
            if( sort == 'parents')
               sort = tableState.sort.reverse ? 'maxParent' : 'minParent';
            params['sort'] = sort + ',' + (tableState.sort.reverse ? 'desc' : 'asc');
            params['page'] = pageNr;
            $http.get('/api/tagValues', {
               params: params
            }).then(function(result) {
               $scope.tagValues = result.data._embedded.tagValues;
               $scope.tags = $scope.tagValues;
               pagination.numberOfPages = result.data.page.totalPages;
               pagination.totalItemCount = result.data.page.totalElements;
               $scope.totalTags = result.data.page.totalElements;
               $scope.tagValues.forEach(function(tagValue) {
                  $scope.resolveStyles(tagValue);
                  $scope.readTagParents(tagValue);
               });
            });
         };
         $scope.refreshTags = this.refreshTags;
      }],
      controllerAs: 'ctrl',
      link: function(scope, elem, attrs) {
         
         scope.timeout = $timeout;
         
         scope.deleteButtonOpen=false;
         
         scope.resetNewTag = function()
         {
            scope.newTag = {
                  log: scope.selectedLog._links.self.href,
                  styles: []
            };
            
            scope.parentTagValues[null] = [];
            scope.parentTagValueObjects[null] = [];
         };
         scope.resetNewTag();
         scope.setNewTagField = function(field, $data)
         {
            scope.newTag[field] = $data;
         };
         
         scope.editable = scope.selectedLog.adminRequiredForTagEdit
            ? scope.selectedLog.role == 'ADMIN'
            : scope.selectedLog.role != 'READ';

         scope.readTagParents = function(tagValue)
         {
            scope.parentTagValues[tagValue.id] = [];
            scope.parentTagValueObjects[tagValue.id] = [];
            var parents = tagValue.parents
               ? tagValue.parents
               : tagValue._embedded.parents;
            parents && parents.forEach(function(parent) {
               scope.parentTagValues[tagValue.id].push(parent._links.self.href.replace(/\{.*\}/,''));
               scope.parentTagValueObjects[tagValue.id].push(parent);
            });
         };
         
         scope.doTagValueParentEdit = function(tagValue)
         {
            scope.editTagValueParent = tagValue; 
            $timeout(function() {$('#tag-selector-'+tagValue.id).focus(); });
         };
         
         scope.parentTagSelectedForNewTag = function() {
            if( scope.parentTagValues[null].length )
               scope.newTag.parents = scope.parentTagValues[null];
            else
               delete scope.newTag.parent;
         };
         
         scope.updatedParentTag = function(tagValue)
         {
               scope.updateTag(tagValue);
               delete scope.editTagValueParent;
               delete scope.tagParentError;
         };
         
         scope.removeParentTag = function(tagValue, removeParent)
         {
            var parents = [];
            tagValue.parents.forEach(function(parent) {
               if(parent != removeParent )
                  parents.push(parent._links.self.href.replace(/\{.*\}/,''));
            });
            $http.patch(tagValue._links.self.href, {
               parents: parents
            }).then(function(result) {
               scope.updateTag(result.data);
            });
         }
         
         scope.getTagCheckRequest = function(stringValue) {
             return $http.get('/api/tagValues', {
                 params: {
                     'log': scope.selectedLog.id,
                     'stringValue': stringValue,
                     'size': 1
                 }
             });
         };
         scope.addTag = function() {
            scope.$broadcast('saveStyles', 'new');
            var d = $q.defer();
            if( !scope.newTag.stringValue )
            {
                handleFormError(d, scope.newTagValueForm, [{
                    "property": "stringValue",
                    "message": "Tag is required."
                }]);
                return d.promise;
            };
            if( scope.newTag.priority && scope.newTag.priority.trim().length)
            {
               var re = new RegExp('^[0-9]+$');
               if( !re.test(scope.newTag.priority))
               {
                   handleFormError(d, scope.newTagValueForm, [{
                       "property": "priority",
                       "message": "Priority must be an integer."
                   }]);
                   return d.promise;
               }
            }
            scope.getTagCheckRequest(scope.newTag.stringValue).then(function(tagCheckResult) {
                if( tagCheckResult.data._embedded.tagValues.length > 0 )
                {
                   handleFormError(d, scope.newTagValueForm, [{
                       "property": "stringValue",
                       "message": "Tag " + scope.newTag.stringValue + " already exists."
                   }]);
                }
                else
                {
                    $http.post('/api/tagValues', scope.newTag, {
                        'noErrorPopup' : true,
                        'rawError' : true
                     }).then(function(result) {
                        scope.updateTag(result.data, true);
                        scope.resetNewTag();
                        scope.readTagParents(result.data);
                        d.resolve();
                        $timeout(function() {
                           scope.$broadcast('updateSelectedStyles', 'new');
                        });
                     }, function(errors) {
                        handleFormError(d, scope.newTagValueForm, errors);
                     });
                }
            });
            return d.promise;
         };
         
         scope.deleteTag = function(tag) {
            $http.delete(tag._links.self.href).then(function() {
               var btn = $('#deleteTagValueButton');
               btn.css('display','none');
               $(document.body).append(btn);
               for( var i=0; i < scope.tagValues.length; i++ )
               {
                  if( scope.tagValues[i]._links.self.href == tag._links.self.href )
                     scope.tagValues.splice(i,1);
               }
               scope.totalTags -= 1;
            });
         };
         
         scope.updateTagValueField = function(tagValue, field, data)
         {
            var update = {};
            if( !data || !data.trim() )
               data = null;
            update[field] = data;
            var deferred = $q.defer();
            var tagCheckDeferred = $q.defer();
            if( field == 'stringValue' )
            {
               scope.getTagCheckRequest(data).then(function(result) {
                   if( result.data._embedded.tagValues.length > 0 )
                   {
                       deferred.reject("Tag " + data + " already exists.");
                       tagCheckDeferred.reject();
                   }
                   else
                       tagCheckDeferred.resolve();
               });
            }
            else if( field == 'priority' && data && data.trim().length )
            {
                var re = new RegExp('^[0-9]+$');
                if( !re.test(data) )
                {
                   deferred.reject("Priority must be an integer.");
                   tagCheckDeferred.reject();
                }
                else
                    tagCheckDeferred.resolve();
            }
            else
                tagCheckDeferred.resolve();
            
            tagCheckDeferred.promise.then(function() {
                $http.patch(tagValue._links.self.href, update, 
                        {'noErrorPopup': true,
                         'noValue': true}).then(function(result) {
                           scope.updateTag(result.data);
                           deferred.resolve();
                        }, function(error) {
                            deferred.reject(error);
                        });
            });
            return deferred.promise;
         };

         scope.updateStyles = function(tagValue)
         {
            return $http.patch(tagValue._links.self.href, {
               'styles' : tagValue.styles
            });
         }
         
         scope.getTagStyles = function(tag) {
            var res = '';
            tag.styles.forEach(function(style) {
               res += style.name + ' ';
            });
            return res;
         };         

         scope.cancelDeleteTagValue = function()
         {
            var btn = $('#deleteTagValueButton');
            btn.css('display', 'none');
            if( scope.deleteButtonToRestore )
               scope.deleteButtonToRestore.css('display', 'block');
         }
         
         scope.showDeleteConfirm = function($event, tagValue)
         {
            var btn = $('#deleteTagValueButton');
            $($event.currentTarget).css('display','none');
            btn.css('display', 'block');
            $($event.currentTarget.parentElement).append(btn);
            scope.deleteButtonToRestore = $($event.currentTarget);
            scope.deleteButtonOpen = true;
            scope.tagValueToDelete = tagValue;
         }
         
         scope.cancelDeleteParent = function()
         {
            var btn = $('#deleteTagValueParentButton');
            btn.css('display', 'none');
            if( scope.deleteParentButtonToRestore )
               scope.deleteParentButtonToRestore.css('display', 'inline-block');
         }
         
         scope.showDeleteParentConfirm = function($event, tagValue, parent)
         {
            var btn = $('#deleteTagValueParentButton');
            $($event.currentTarget).css('display','none');
            btn.css('display', 'inline-block');
            $($event.currentTarget).after(btn);
            scope.deleteParentButtonToRestore = $($event.currentTarget);
            scope.deleteParentButtonOpen = true;
            scope.tagValueToRemoveParent = tagValue;
            scope.parentToRemove = parent;
         }
         
         scope.updateTag = function(updatedTagValue, isNew)
         {
            $http.get(updatedTagValue._links.self.href, {
               params: {
                  'projection':'tagValueProjectionWithParents'
               }}).then(function(result ) {
                  updatedTagValue = result.data;
                  scope.resolveStyles(updatedTagValue);
                  if( !isNew)
                  {
                     for( var i=0; i < scope.tagValues.length; i++ )
                     {
                        if( scope.tagValues[i]._links.self.href == updatedTagValue._links.self.href )
                        {
                           angular.extend(scope.tagValues[i], updatedTagValue);
                           scope.readTagParents(scope.tagValues[i]);
                        }
                     }
                     
                  }
                  else
                  {
                     scope.totalTags += 1;
                     scope.tagValues.splice(0,0,updatedTagValue);
                  }
               });
          };

      }
    };
  }]);
